import { FORM_INPUTS } from "./formInputs";

export const generateOrderDTO = (amount, currencyNumericCode) => {
    const address = FORM_INPUTS.address.element;
    const city = FORM_INPUTS.city.element;
    const zipCode = FORM_INPUTS.zipCode.element;

    return {
        "Consumer": {
            "Email1": FORM_INPUTS.email.element.value,
            "BillingAddress": {
                "FullName": FORM_INPUTS.cardHolder.element.value,
                "Address1": address ? address.value : null,
                "City": city ? city.value : null,
                "PostalCode": zipCode ? zipCode.value : null
            },
            "Account": {
                "AccountNumber": FORM_INPUTS.cardNumber.element.value.replace(/\s/g, ''),
                "ExpirationMonth": FORM_INPUTS.oneExpiryInput.element ? FORM_INPUTS.oneExpiryInput.element.value.substring(0, FORM_INPUTS.oneExpiryInput.element.value.indexOf('/')) : FORM_INPUTS.monthExpiry.element.value,
                "ExpirationYear": FORM_INPUTS.oneExpiryInput.element ? '20' + FORM_INPUTS.oneExpiryInput.element.value.slice(FORM_INPUTS.oneExpiryInput.element.value.indexOf('/') + 1) : FORM_INPUTS.yearExpiry.element.value,
                "CardCode": FORM_INPUTS.cvv.element.value,
                "NameOnAccount": FORM_INPUTS.cardHolder.element.value
            }
        },
        "OrderDetails": {
            "Amount": amount,
            "CurrencyCode": currencyNumericCode
        }
    };
}